
import { defineComponent, inject, PropType } from "vue";
import { ciTrackingService } from "@services/ci-tracking.service";
import { settingsService } from "@services/settings.service";
import { ROUTENAMES } from "@models/constants/routes";
import { useRouter } from "vue-router/composables";
import CiButton from "@components/base/button.vue";
import CiInterestTags from "@components/tags/interest-tags.vue";

export default defineComponent({
  name: "CiUsersProfileInterestTags",
  components: { CiButton, CiInterestTags },
  props: {
    items: {
      type: Array as PropType<Products.InterestTagsList>,
      default: () => [],
    },
    owner: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const router = useRouter();
    const trackingUserType = inject<string>("trackingUserType");
    const userId = inject<number>("userId");

    const userHasDefaultInterests = settingsService.options.user.show_interest_tag_selection;

    const handleEditInterestTagsClick = async () => {
      await trackUserAction();

      await router.push({ name: ROUTENAMES.USERS_SETTINGS, query: { tab: "my_interests" } });
    };

    const trackUserAction = async () => {
      await ciTrackingService.trackClick("ButtonUserProfileInterests", userId?.toString(), trackingUserType);
    };

    return {
      userHasDefaultInterests,
      handleEditInterestTagsClick,
      trackingUserType,
    };
  },
});
